<template>
  <!-- 产品功能详情页 -->
  <div class="container">
    <Menu :page="1"></Menu>
    <section class="section banner">
      <h1 class="h1">
        <p v-for="(title, index) in titleList" :key="index">{{ title }}</p>
      </h1>
      <div class="p-wrap">
        <p v-for="(p, index) in pList" :key="index">{{ p }}</p>
      </div>
      <div class="banner-box">
        <img :src="banner" />
      </div>
      <div class="btn-box flex-row">
        <Button type="primary" plain @click="goContact">立即咨询</Button>
      </div>
    </section>
    <section class="section function">
      <div class="header">
        <h2 class="h2">产品功能</h2>
        <div class="header-box flex-row">
          <div class="left">功能</div>
          <div class="right">说明</div>
        </div>
        <div class="body">
          <div
            class="row flex-row"
            v-for="(row, index) in rowList"
            :key="index"
          >
            <div class="left">{{ row.title }}</div>
            <div class="right">{{ row.explain }}</div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import Menu from "@/components/menu.vue";
import Footer from "@/components/footer.vue";
import { Button } from "vant";
export default {
  components: {
    Menu,
    Footer,
    Button,
  },
  data() {
    return {
      titleList: [],
      pList: [],
      rowList: [],
      banner: "",
    };
  },
  mounted() {
    switch (this.$route.query.type) {
      case "1":
        this.titleList = ["专属可控的团队", "即时通讯"];
        this.pList = [
          "专属企业内部通讯系统，账号独立分",
          "配，无需员工私人手机号、微信号，可",
          "控的员工账号及信息展示",
        ];
        this.banner = require("@/assets/images/product/im_banner.png");
        this.rowList = [
          {
            title: "无障碍沟通协作",
            explain:
              "丰富的消息发送格式、文件传输功能，满足了工作日常的沟通协作需求，降低了沟通成本。",
          },
          {
            title: "企业通讯录高度保密",
            explain:
              "组织部门通讯录，互加好友才能聊天；高级权限可查看所有人及直接对话，保障企业人员数据安全",
          },
          {
            title: "员工司龄、信息一览无遗",
            explain:
              "员工基本信息可查，高级管理权限可查看司龄、电话、所属部门、上级领导、培训记录等信息；为管理者提供各项数据依据，随时调阅",
          },
          {
            title: "高清音视频通话",
            explain:
              "支持语音、视频直接通话，支持群聊视频，满足线上短会、沟通需求",
          },
        ];
        break;
      case "2":
        this.titleList = ["独立邮箱系统", "更放心"];
        this.pList = ["安全保密的内部邮箱系统，邮件发送", "及时，记录查询方便"];
        this.banner = require("@/assets/images/product/email_banner.png");
        this.rowList = [
          {
            title: "快捷、安全邮件即达",
            explain: "独立的邮件系统，无需维护员工账号，不止安全，更快捷",
          },
          {
            title: "邮件也需要打草稿",
            explain:
              "邮件可编辑丰富的图文内容，添加附件，还可以存储为草稿以便后续编辑",
          },
        ];
        break;
      case "3":
        this.titleList = ["企业资料都", "交给小π云盘"];
        this.pList = ["高效内部资料云盘，文件存储备份，", "随时随地调用"];
        this.banner = require("@/assets/images/product/disk_banner.png");
        this.rowList = [
          {
            title: "安全内部云盘",
            explain: "文件存取更方便，文件备份不丢失，银行级数据安全保障",
          },
          {
            title: "云盘文件共享",
            explain:
              "文件支持指定人员或团队共享，可转发至聊天或群，实现文件的协作管理",
          },
        ];
        break;
      case "4":
        this.titleList = ["一个文档", "无限的可能"];
        this.pList = [
          "一个文档支持多人编辑创作，让你的内",
          "容创作效率、思路拥有无限可能",
        ];
        this.banner = require("@/assets/images/product/onile_banner.png");
        this.rowList = [
          {
            title: "多人协作编辑创作",
            explain: "支持多人协作文档，实时编辑查看",
          },
          {
            title: "一个有时间轴的文档",
            explain: "文档历史记录支持回档，写错了也不要紧，无数版本由你来定",
          },
          {
            title: "文档共享新思路",
            explain: "没有思路？共享你的文档，让更多人一起添加想法",
          },
        ];
        break;
      case "5":
        this.titleList = ["企业的基石", "科学的组织架构"];
        this.pList = [
          "企业数字化开端，组织体系建立，权限",
          "分配，职业晋升通道",
        ];
        this.banner = require("@/assets/images/product/jiagou_banner.png");
        this.rowList = [
          {
            title: "科学的组织管理",
            explain:
              "可视化的组织架构、编制维护，灵活设置避免臃肿的架构，适应企业高速发展",
          },
          {
            title: "便捷人员、权限管理",
            explain: "分部门、人员权限管理，权限切分清晰",
          },
          {
            title: "一站式职位晋升通道",
            explain:
              "合理规划职位需求，制定晋升通道，为企业量身定制人才战略发展方案",
          },
        ];
        break;
      case "6":
        this.titleList = ["有深度的员工", "成长管理"];
        this.pList = [
          "员工成长、晋升、盘点，不做表面工",
          "作，多维度有深度的管理模式",
        ];
        this.banner = require("@/assets/images/product/renshi_banner.png");
        this.rowList = [
          {
            title: "全面的员工信息",
            explain: "员工花名册信息、合同信息档案维护，信息完整性预警",
          },
          {
            title: "综合成长记录",
            explain:
              "从入职开始，员工的晋升异动，培训、学习记录始终伴随成长记录，优秀的成长轨迹可成为标杆",
          },
          {
            title: "灵动的员工关系",
            explain:
              "人事异动、员工奖惩、转正、晋升一体维护，处处记录，挪转灵动",
          },
          {
            title: "做有温度的员工管理",
            explain:
              "员工入职信件提醒，员工生日、入职周年智能邮件提醒，关怀员工的生活工作",
          },
        ];
        break;
      case "7":
        this.titleList = ["企业招聘新通路"];
        this.pList = [
          "为企业的招聘工作提供可管理可存档的",
          "记录，并且提供一套标准的人才筛选流",
          "程，加快企业的招聘进程",
        ];
        this.banner = require("@/assets/images/product/zhaopin_banner.png");
        this.rowList = [
          {
            title: "职位招聘库",
            explain: "人事岗位需求统计、招聘任务分配，实时监控招聘进程",
          },
          {
            title: "招聘、筛选、入职一条龙",
            explain:
              "招聘进度监控，人才质量筛选，面试日程安排，面试通过后可自动迁移至员工花名册，招聘一条龙",
          },
          {
            title: "面试档期同步安排",
            explain: "面试预约自动同步面试日程表，一目了然、减少行程沟通",
          },
          {
            title: "打造企业人才库",
            explain: "优秀人才一键储备，打造属于企业的人才库",
          },
          {
            title: "看得见的招聘成效",
            explain:
              "招聘质量、进度、渠道效果等多维度统计分析，实时图表显示，成效看得见",
          },
        ];
        break;
      case "8":
        this.titleList = ["并不为了约束", "而考勤"];
        this.pList = [
          "实时统计考勤信息，考勤排行榜激励，",
          "不为约束，只为行为养成",
        ];
        this.banner = require("@/assets/images/product/kaoqin_banner.png");
        this.rowList = [
          {
            title: "灵活高适应性规则设置",
            explain:
              "早晚打卡、分段打卡班次维护，考勤规则适用多样化的考勤规则需求",
          },
          {
            title: "汇总报表",
            explain: "员工考勤数据统计汇总，可导出报表",
          },
          {
            title: "考勤通知，智能统计",
            explain:
              "人事异动、员工奖惩、转正、晋升一体维护，处处记录，挪转灵动",
          },
          {
            title: "考勤排行榜",
            explain:
              "员工入职信件提醒，员工生日、入职周年智能邮件提醒，关怀员工的生活工作",
          },
        ];
        break;
      case "9":
        this.titleList = ["承包企业的", "所有审批事项"];
        this.pList = [
          "无纸化审批流程，满足考勤、财务、",
          "行政等事务的在线审批",
        ];
        this.banner = require("@/assets/images/product/oa_banner.png");
        this.rowList = [
          {
            title: "内置丰富表单",
            explain: "内置考勤、行政、财务方面丰富的表单，易用性套件，开箱即用",
          },
          {
            title: "审批智能工作提醒",
            explain: "智能提醒审批进度以及待审批事项，重要事项不遗漏",
          },
        ];
        break;
      case "10":
        this.titleList = ["快速流转的无纸化", "绩效考核"];
        this.pList = ["无纸化绩效考核，考核流程自动流转"];
        this.banner = require("@/assets/images/product/jixiao_banner.png");
        this.rowList = [
          {
            title: "快速制定团队专属考核计划",
            explain: "指定团队的考核计划制定，指标灵活、流程自定",
          },
          {
            title: "流程自动流转",
            explain:
              "一次设定流程，节点自动流转，无需反复文件转交，最终评分自动核算",
          },
        ];
        break;
      case "11":
        this.titleList = ["保密、高效的", "薪酬核算系统"];
        this.pList = [
          "解决企业工资核算的繁琐及过程管控",
          "问题，考勤、绩效数据的自动关联",
        ];
        this.banner = require("@/assets/images/product/xinchou_banner.png");
        this.rowList = [
          {
            title: "工资模板薪资快速安全搞定",
            explain:
              "按需求定制工资模板、薪酬规则；员工薪资一键定薪、调薪，按部门权限进行数据的切分保障信息安全",
          },
          {
            title: "跨模块自动读取数据",
            explain: "自动同步绩效分数，拉取考勤数据，一键生成工资表",
          },
        ];
        break;
      case "12":
        this.titleList = ["企业精神的丰碑", "文化的沉淀"];
        this.pList = ["企业的动态宣传，企业成长里程碑，", "企业文化宣导及沉淀"];
        this.banner = require("@/assets/images/product/news_banner.png");
        this.rowList = [
          {
            title: "企业大事记",
            explain: "实时记录企业事迹，拥有属于自己的企业新闻",
          },
          {
            title: "企业新鲜事",
            explain: "企业的精彩瞬间、新鲜事，一键直达",
          },
        ];
        break;
      case "13":
        this.titleList = ["专业的行业", "专业的资讯"];
        this.pList = ["行业领域知识储备，完善属于企业自", "己的行业百科资讯"];
        this.banner = require("@/assets/images/product/zixun_banner.png");
        this.rowList = [
          {
            title: "行业百科资讯",
            explain: "构建企业专业领域行业百科，知识储备，员工培训都在行",
          },
        ];
        break;
      case "14":
        this.titleList = ["文化载体的电子", "革新之路"];
        this.pList = [
          "随时随地阅读，文化底蕴跃然纸上，",
          "以电子的方式传递文化",
        ];
        this.banner = require("@/assets/images/product/neikan_banner.png");
        this.rowList = [
          {
            title: "企业文化新载体",
            explain:
              "传统的企业报刊载体在传播、存储方式无法适应时代变更，电子载体的出现为企业文化的宣导提供新颖便捷的方式",
          },
          {
            title: "拟物化的设计",
            explain:
              "内刊列表采用拟物化的交互设计，让内刊的电子化不再是普通的形式转变，更凸显刊物的真实感",
          },
        ];
        break;
      case "15":
        this.titleList = ["人性化企业", "拥有自己的“朋友圈”"];

        this.pList = [
          "咱企业自己的朋友圈，增进同事间的",
          "了解，提升工作氛围的融洽度",
        ];
        this.banner = require("@/assets/images/product/pyq_banner.png");
        this.rowList = [
          {
            title: "同事好友动态",
            explain: "查看好友动态，了解同事的最新动态，互相关心，开心工作",
          },
          {
            title: "“负能量”管理员",
            explain:
              "不用担心好友圈的负能量，超级朋友圈管理员出马，扫除一切负能量",
          },
        ];
        break;
      case "16":
        this.titleList = ["你有知识、干货", "我有“月光宝盒”"];
        this.pList = [
          "企业内部学习互动社区，企业知识储",
          "备、学习互动模块，企业文化建设、提",
          "升员工组织认同感",
        ];
        this.banner = require("@/assets/images/product/ygbh_banner.png");
        this.rowList = [
          {
            title: "企业文化、知识的沉淀",
            explain:
              "可自由的发布知识型内容的文章，支持上传图片、视频，内容丰富，时光变迁，知识永流传",
          },
          {
            title: "互助问答社区",
            explain: "问答互动，营造企业良好的学习互助氛围",
          },
          {
            title: "知识等级体系",
            explain:
              "发布越多的文章，获得别人的点赞、关注，等级会越来越高，提升员工的成就感，也可作为年度评分的依据",
          },
        ];
        break;
      case "17":
      case "18":
      case "19":
      case "20":
      case "21":
        this.titleList = ["行政管理"];
        this.pList = ["给企业带来全面的资产数字化服务,", "科学的资产盘点"];
        this.banner = require("@/assets/images/product/xzgl_banner.png");
        this.rowList = [
          {
            title: "资产管理",
            explain:
              "配合OA审批进行数字化的资产入库 、出库管理，涵盖虚拟账号资产、办公资产、企业车辆油卡等类型，解决繁杂的表格管理，资产一目了然。",
          },
          {
            title: "文件用印",
            explain:
              "集成OA审批进行文件、合同等资料的存档租借，以及用印管理等行政事务的记录。",
          },
          {
            title: "群管理",
            explain:
              "实时显示群组列表信息，智能统计每日、每月群活跃及考核合格率，为管理者提供数据参照。",
          },
          {
            title: "系统消息",
            explain: "一键发布重要通知，快速传达。",
          },
          {
            title: "检举揭发",
            explain: "为企业管理者提供内部检举机制，防范企业管理风险。",
          },
        ];
        break;
      case "22":
        this.titleList = ["成长式在线", "培训任务体系"];
        this.pList = [
          "员工培训效率提升，减少重复性培训，",
          "文化培训、业务培训课件有效权限切",
          "分，保障培训内容保密性",
        ];
        this.banner = require("@/assets/images/product/sxy_banner.png");
        this.rowList = [
          {
            title: "培训线路一目了然",
            explain:
              "管理层能够看到员工个人主页的培训记录，对员工培训任务、课程的进度一目了然，实时追踪培训成果",
          },
          {
            title: "成长任务引导追踪",
            explain: "快捷发布培训任务，数据统计追踪，系统的引导员工如何学习",
          },
          {
            title: "企业私有云课程",
            explain:
              "云端课程发布，课件管理；课程可进行有效的权限分割，有效保障课程保密性",
          },
          {
            title: "多端随时随地在线学习",
            explain: "员工可在移动端、PC端随时随地进行课程学习；",
          },
          {
            title: "在线考试成果验收",
            explain: "在线试题维护，考试任务发布指定到个人，配套培训成果验收",
          },
        ];
        break;
      case "23":
        this.titleList = ["先进的视频会议", "软硬件生态"];
        this.pList = [
          "解决远程会议、线上办公、线上培训软",
          "硬件生态，适应疫情当下企业办公需求",
        ];
        this.banner = require("@/assets/images/product/sphy_banner.png");
        this.rowList = [
          {
            title: "多系统平台会议终端",
            explain: "跨设备多人多端，随时随地发起视频会议",
          },
          {
            title: "可回放可掌控的会议",
            explain:
              "会议记录保存，回放，上级可查看下级会议记录，无需参与也能掌握会议情况",
          },
          {
            title: "低延迟屏幕共享",
            explain: "在线教学、培训，手把手教学",
          },
          {
            title: "视频会议硬件生态",
            explain:
              "定制化硬件设备生态开发，多场景适用会议大屏，给企业会议增添新活力",
          },
        ];
        break;
      default:
        break;
    }
  },
  methods: {
    goContact() {
      this.$router.push("/contact");
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .section {
    &.banner {
      background: linear-gradient(135deg, #e0fdfe 0%, #eff4ff 100%);
      padding: 40px 0 30px;
      .h1 {
        text-align: center;
        font-size: 38px;
        font-weight: 600;
        color: #181818;
        margin-bottom: 24px;
      }
      .p-wrap {
        text-align: center;
        margin-bottom: 15px;
        p {
          line-height: 24px;
          font-size: 16px;
          color: #595959;
          font-weight: 400;
        }
      }
      .banner-box {
        padding: 0 24px;
        margin-bottom: 35px;
        img {
          display: block;
          width: 100%;
        }
      }
      .btn-box {
        justify-content: center;
        margin-bottom: 30px;
        .van-button {
          width: calc((100% - 20px) / 2);
          color: #00b7a5;
          border-color: #00b7a5;
          font-size: 16px;
          font-weight: 600;
          user-select: none;
          border-radius: 4px;
        }
        .van-button--primary {
          color: #00b7a5;
        }
        .van-button--plain {
          background-color: transparent;
        }
      }
    }
    &.function {
      padding: 20px 16px;
      .header {
        .h2 {
          font-weight: 500;
          font-size: 18px;
          color: #181818;
        }
        .header-box {
          margin-top: 14px;
          height: 42px;
          background: #f2f2f2;
          font-size: 14px;
          font-weight: 500;
          color: #181818;
          .left {
            width: 40%;
            padding: 15px 10px;
          }
          .right {
            width: 60%;
            padding: 15px 10px;
          }
        }
        .body {
          margin-bottom: 15px;
          .row {
            font-size: 14px;
            font-weight: 400;
            color: #181818;
            position: relative;
            &::after {
              content: "";
              width: 100%;
              height: 1px;
              background-color: #dfdfdf;
              position: absolute;
              left: 0;
              bottom: 0;
              transform: scaleY(0.5);
            }
            .left {
              width: 40%;
              padding: 15px 10px;
            }
            .right {
              width: 60%;
              padding: 15px 10px;
              position: relative;
              &::after {
                content: "";
                width: 1px;
                height: 100%;
                background-color: #dfdfdf;
                position: absolute;
                left: 0;
                top: 0;
                transform: scaleX(0.5);
              }
            }
          }
        }
      }
    }
  }
}
</style>
